import TaxiCorporationUnbilledOrdersListResponse, {
  TaxiCorporationUnbilledOrdersListResponseData,
  TaxiCorporationUnbilledOrdersListResponseDataItem,
  TaxiCorporationUnbilledOrdersListResponseDataItemMissingBillings,
} from "../../../../api/raily/taxi-corporation/unbilled/orders-list/taxi-corporation-unbilled-orders-list.response";
import TaxiCorporationUnbilledOrdersList, {
  TaxiCorporationUnbilledOrdersListItem,
  TaxiCorporationUnbilledOrdersListItemMissingBillings,
} from "./taxi-corporation-unbilled-orders-list";

const createMissingBilling = (
  missingBilling: TaxiCorporationUnbilledOrdersListResponseDataItemMissingBillings,
): TaxiCorporationUnbilledOrdersListItemMissingBillings => {
  switch (missingBilling) {
    case TaxiCorporationUnbilledOrdersListResponseDataItemMissingBillings.CARGO_TAXI:
      return TaxiCorporationUnbilledOrdersListItemMissingBillings.CARGO_TAXI;
  }
};

const createMissingBillings = (
  missingBillings: TaxiCorporationUnbilledOrdersListResponseDataItemMissingBillings[],
): TaxiCorporationUnbilledOrdersListItemMissingBillings[] => {
  return missingBillings.map(createMissingBilling);
};

const createDataItem = (
  item: TaxiCorporationUnbilledOrdersListResponseDataItem,
): TaxiCorporationUnbilledOrdersListItem => {
  return {
    client: item.client,
    dispatch: item.dispatch,
    drivers: item.drivers,
    externalId: item.externalId,
    humanId: item.humanId,
    uuid: item.id,
    isCancelled: item.isCancelled,
    missingTaxiBillings: createMissingBillings(item.missingTaxiBillings),
    passengers: item.passengers,
    rideAddresses: item.rideAddresses,
    startTime: item.startTime,
    taxiCorporations: item.taxiCorporations,
  };
};

const createDataItems = (
  items: TaxiCorporationUnbilledOrdersListResponseDataItem[],
): TaxiCorporationUnbilledOrdersListItem[] => {
  return items.map(createDataItem);
};

const createData = (
  data: TaxiCorporationUnbilledOrdersListResponseData,
): TaxiCorporationUnbilledOrdersList => {
  return {
    data: createDataItems(data.data),
    totalCount: data.totalCount,
  };
};

const create = (
  response: TaxiCorporationUnbilledOrdersListResponse,
): TaxiCorporationUnbilledOrdersList => {
  return createData(response.data);
};

const taxiCorporationUnbilledOrdersListFactory = {
  create,
};

export default taxiCorporationUnbilledOrdersListFactory;
